/**
 * @generated SignedSource<<c41f7f0ffb88b8dd70453d2b6a84f569>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type BreadcrumbForHolderCity_post$data = {
  readonly slug: string
  readonly h1: string
  readonly holder_city: {
    readonly cityId: number
    readonly name: string
    readonly designatedCity: {
      readonly designatedCityId: number
      readonly name: string
    } | null
    readonly prefectureName: string
    readonly prefectureRoma: string
  } | null
  readonly ' $fragmentType': 'BreadcrumbForHolderCity_post'
}
export type BreadcrumbForHolderCity_post$key = {
  readonly ' $data'?: BreadcrumbForHolderCity_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'BreadcrumbForHolderCity_post'>
}

const node: ReaderFragment = (function () {
  var v0 = {
    alias: null,
    args: null,
    kind: 'ScalarField',
    name: 'name',
    storageKey: null
  }
  return {
    argumentDefinitions: [],
    kind: 'Fragment',
    metadata: null,
    name: 'BreadcrumbForHolderCity_post',
    selections: [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'slug',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'h1',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        concreteType: 'City',
        kind: 'LinkedField',
        name: 'holder_city',
        plural: false,
        selections: [
          {
            alias: 'cityId',
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null
          },
          v0 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'CitySimple',
            kind: 'LinkedField',
            name: 'designatedCity',
            plural: false,
            selections: [
              {
                alias: 'designatedCityId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null
              },
              v0 /*: any*/
            ],
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'prefectureName',
            storageKey: null
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'prefectureRoma',
            storageKey: null
          }
        ],
        storageKey: null
      }
    ],
    type: 'Post',
    abstractKey: null
  }
})()

;(node as any).hash = '201399001a9c1eed3e141ccee135fc2b'

export default node
